import { SideBar } from '../../models/sideBar';
import { assetsConst } from './assets.const';
import { ModuleConst } from './moduleConst';

export const SideBarConst: Array<SideBar> = [
  {
    text: 'SIDEBARTEXT.DASHBOARD',
    path: '/dashboard',
    icon: assetsConst.dashBoardIcon,
    isSubMenu: false,
    sideBarId: ModuleConst.Dashboard
  },

  {
    text: 'SIDEBARTEXT.manageProducts',
    path: '/products',
    isSubMenu: false,
    icon: assetsConst.ProductIcon,
    sideBarId: ModuleConst.Products
  },

  // {
  //   text: 'ManageBrands',
  //   path: '/manage-brands',
  //   icon: assetsConst.ProductIcon,
  //   isSubMenu: false,
  //   sideBarId: ModuleConst.Brands
  // },

  {
    text: 'SIDEBARTEXT.orderManagement',
    path: '/manage-order',
    icon: assetsConst.OrderIcon,
    isSubMenu: true,
    sideBarId: ModuleConst.Orders,
    subMenuItems: [
      {
        text: 'SIDEBARTEXT.orderManagement',
        path: '/manage-order',
        icon: assetsConst.OrderIcon,
        isSubMenu: false,
        sideBarId: ModuleConst.orderManagement
      },
      {
        text: 'SIDEBARTEXT.Returns',
        path: '/manage-order/returns/0/1',
        isSubMenu: false,
        sideBarId: ModuleConst.Returns
      }
    ]
  },
  {
    text: 'ManageOutlets',
    path: '/manage-outlet/list/1',
    icon: assetsConst.EarningIcon,
    isSubMenu: false,
    sideBarId: ModuleConst.Outlets
  },
  {
    text: 'SIDEBARTEXT.manageReviews',
    path: '/manage-review',
    icon: assetsConst.starIcon,
    isSubMenu: false,
    sideBarId: ModuleConst.Reviews
  },
  // {
  //   text: 'SIDEBARTEXT.manageEarnings',
  //   path: '/manage-payment',
  //   icon: assetsConst.EarningIcon,
  //   isSubMenu: false,
  //   sideBarId: ModuleConst.Analytics
  // },
  {
    text: 'SIDEBARTEXT.reportManagement',
    path: '/report-management',
    icon: assetsConst.reportIcon,
    isSubMenu: false,
    sideBarId: ModuleConst.Reports
  },
  {
    text: 'SIDEBARTEXT.ManageSubAdmin',
    path: '/subadmin',
    icon: assetsConst.cmsIcon,
    isSubMenu: false,
    sideBarId: ModuleConst.SubAdmin
  },
  // {
  //   text: 'SIDEBARTEXT.SETTING',
  //   path: '/setting',
  //   icon: assetsConst.cmsIcon,
  //   isSubMenu: false,
  //   sideBarId: ModuleConst.Settings
  // }
];


export const ROLE = {
  ADMIN: 1,
  SUBADMIN: 2,
  USER: 3,
  VENDOR: 4,
  FACTORY: 5,
  DISPATCHER: 6,
  DRIVER: 7,
  ALL: 8,
  FACTORYMANAGER: 9,
  SALESMANAGER: 10,
  SUBSALESMANAGER: 11,
  EMPLOYEE: 12,
  SUBVENDOR: 13,
}